import styled from 'styled-components';
import { primaryBlue } from '../models/colors';
import Logo from './footer/allison-white.svg?react';

const StyledFooter = styled('footer')`
	display: flex;
	padding: 24px 24px;
	justify-content: space-between;
	align-items: center;
	background-color: ${primaryBlue};
`;

export const Footer = () => {
	return (
		<StyledFooter>
			<span style={{ fontSize: '0.75rem', color: '#FFFFFF' }}>Copyright 2019 Allison Transmission Inc.</span>
			<Logo />
		</StyledFooter>
	);
};
